import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { RadioError } from 'components/fields'
import styles from './radio-group.styl'

export default class RadioGroup extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    label: PropTypes.string,
    intlKey: PropTypes.string,
    name: PropTypes.string,
    fields: PropTypes.object,
    errors: PropTypes.object,
    disabled: PropTypes.bool,
    horizontal: PropTypes.bool
  }
  static defaultProps = {
    horizontal: false
  }

  render() {
    const {
      label,
      children,
      horizontal,
      disabled,
      fields,
      errors,
      name,
      intlKey
    } = this.props

    return (
      <div className={styles.formGroup}>
        {label &&
          <div>
            <span className="control-label">
              {intlKey
                ? <FormattedMessage
                    className="control-label"
                    id={intlKey}
                    defaultMessage={label}
                  />
                : label}
            </span>
          </div>}

        {children.length === 1 && React.cloneElement(children, { horizontal })}
        {children.length > 1 &&
          children.map(
            (item, index) =>
              item &&
              React.cloneElement(item, { horizontal, key: index, disabled })
          )}

        {name &&
          errors &&
          <RadioError
            error={errors[name]}
            touched={fields && fields[name] && fields[name].touched}
          />}

      </div>
    )
  }
}
